import { Chat, ThreadChat } from '@src/api/shared/community/chatApiClient';
import React from 'react';

type ChatUnreadLineProps = {
  shouldShowUnreadLine: (chatId: number) => boolean;
  chat: Chat | ThreadChat;
};

const ChatUnreadLine: React.FC<ChatUnreadLineProps> = ({ shouldShowUnreadLine, chat }) => {
  return (
    <>
      {shouldShowUnreadLine(chat.id) && (
        <div className='relative h-px bg-transparent py-[20px]'>
          <div className='absolute left-1/2 top-1/2 h-px w-full -translate-x-1/2 -translate-y-1/2 bg-warning-500'></div>
          <div className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white px-[10px] text-sm font-medium text-warning-500'>
            NEW
          </div>
        </div>
      )}
    </>
  );
};

export default ChatUnreadLine;
